module.exports = __webpack_public_path__ + "img/dolphin.be5030ca.webp";